exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("../fonts/Poiret_One/PoiretOne-Regular.ttf"));

// Module
exports.push([module.id, "@font-face {\n  font-family: \"Titulos\";\n  src: url(" + ___CSS_LOADER_URL___0___ + "); }\n\n@font-face {\n  font-family: \"Links\";\n  src: url(" + ___CSS_LOADER_URL___0___ + "); }\n\nh5 {\n  font-family: \"Titulos\" !important; }\n\nh3 {\n  font-family: \"Titulos\" !important; }\n\na:hover {\n  font-family: 'Links'; }\n\na:link {\n  font-family: 'Links'; }\n\na:visited {\n  font-family: 'Links'; }\n", ""]);

